export default{

	init(){
		$('#sliderPrimary').slick({
			infinite: true,
			autoplay: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: false,
			fade: true
		});
	}

}